/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getTrainingDocuments } from "actions";
import "components/widgets/training/TrainingDetailDocument.css";
import TrainingDetailDocument from "./TrainingDetailDocument";

class TrainingDetailDocuments extends Component {
  state = { trainingDetailDocs: null };

  componentDidMount() {
    this.props.getTrainingDocuments(
      this.props.trainingId,
      () => this.props.onProcessBegin(),
      (res) => {
        this.props.onProcessEnd();
        this.setState({ trainingDetailDocs: res });
      },
      (e) => {
        this.props.onProcessEnd();
        console.dir(e);
      }
    );
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.training !== prevProps.training) {
      this.fetchDocs();
    }
  };

  fetchDocs = () => {
    this.props.getTrainingDocuments(
      this.props.trainingId,
      () => {},
      (res) => {
        this.props.onProcessEnd();
        this.setState({ trainingDetailDocs: res });
      },
      (e) => {
        this.props.onProcessEnd();
        console.dir(e);
      }
    );
  };

  renderDocuments = () => {
    if (!this.state.trainingDetailDocs) return null;
    if (this.state.trainingDetailDocs.length === 0)
      return <div>Doküman bulunamadı.</div>;

    return this.state.trainingDetailDocs.map((document, index) => {
      return <TrainingDetailDocument key={index} document={document} />;
    });
  };

  render() {
    return (
      <>
        {this.props.spinner}
        <div className="training-documents-container">
          {this.renderDocuments()}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getTrainingDocuments,
})(containsLongRunningProcess(TrainingDetailDocuments));
